var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReplaceAsset(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 3,
    y: 3,
    width: 6,
    height: 6,
    rx: 1,
    stroke: "#848A9B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 15,
    y: 15,
    width: 6,
    height: 6,
    rx: 1,
    stroke: "#848A9B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M20.25 11C20.25 11.4142 20.5858 11.75 21 11.75C21.4142 11.75 21.75 11.4142 21.75 11H20.25ZM13 6V5.25C12.6967 5.25 12.4232 5.43273 12.3071 5.71299C12.191 5.99324 12.2552 6.31583 12.4697 6.53033L13 6ZM15.4697 9.53033C15.7626 9.82322 16.2374 9.82322 16.5303 9.53033C16.8232 9.23744 16.8232 8.76256 16.5303 8.46967L15.4697 9.53033ZM16.5303 3.53033C16.8232 3.23744 16.8232 2.76256 16.5303 2.46967C16.2374 2.17678 15.7626 2.17678 15.4697 2.46967L16.5303 3.53033ZM12.4697 5.46967C12.1768 5.76256 12.1768 6.23744 12.4697 6.53033C12.7626 6.82322 13.2374 6.82322 13.5303 6.53033L12.4697 5.46967ZM21.75 11V8H20.25V11H21.75ZM21.75 8C21.75 6.48122 20.5188 5.25 19 5.25V6.75C19.6904 6.75 20.25 7.30964 20.25 8H21.75ZM19 5.25H13V6.75H19V5.25ZM12.4697 6.53033L15.4697 9.53033L16.5303 8.46967L13.5303 5.46967L12.4697 6.53033ZM15.4697 2.46967L12.4697 5.46967L13.5303 6.53033L16.5303 3.53033L15.4697 2.46967Z",
    fill: "#848A9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M3.75 13C3.75 12.5858 3.41421 12.25 3 12.25C2.58579 12.25 2.25 12.5858 2.25 13H3.75ZM11 18V18.75C11.3033 18.75 11.5768 18.5673 11.6929 18.287C11.809 18.0068 11.7448 17.6842 11.5303 17.4697L11 18ZM8.53033 14.4697C8.23744 14.1768 7.76256 14.1768 7.46967 14.4697C7.17678 14.7626 7.17678 15.2374 7.46967 15.5303L8.53033 14.4697ZM7.46967 20.4697C7.17678 20.7626 7.17678 21.2374 7.46967 21.5303C7.76256 21.8232 8.23744 21.8232 8.53033 21.5303L7.46967 20.4697ZM11.5303 18.5303C11.8232 18.2374 11.8232 17.7626 11.5303 17.4697C11.2374 17.1768 10.7626 17.1768 10.4697 17.4697L11.5303 18.5303ZM2.25 13V16H3.75V13H2.25ZM2.25 16C2.25 17.5188 3.48122 18.75 5 18.75V17.25C4.30964 17.25 3.75 16.6904 3.75 16H2.25ZM5 18.75H11V17.25H5V18.75ZM11.5303 17.4697L8.53033 14.4697L7.46967 15.5303L10.4697 18.5303L11.5303 17.4697ZM8.53033 21.5303L11.5303 18.5303L10.4697 17.4697L7.46967 20.4697L8.53033 21.5303Z",
    fill: "#848A9B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplaceAsset);
export default __webpack_public_path__ + "static/media/replace-asset.9d97d6bc3c97758a92843bb1f18a5e5b.svg";
export { ForwardRef as ReactComponent };